import { MenuPositionData } from '../../interfaces';

export const isMenuPositionDataType: (value: unknown) => value is MenuPositionData = (value: unknown): value is MenuPositionData => {
  const menuPositionDataKeys: string[] = [
    'label',
    'externalUrl',
    'shouldOpenInNewTab',
    'internalPath',
    'action',
    'icon',
    'name',
    'childrenPositions',
    'download',
  ];

  return (
    typeof value === 'object'
    && Object.keys(value as Record<string, unknown>).every((key: string): boolean => menuPositionDataKeys.includes(key))
  );
};
